'use strict';
const angular = require('angular');

export class SchemaFormModalComponent {
  /*@ngInject*/
  constructor($scope, PropertyService, ContactService, CommunityService, User, $uibModal, StorageService) {
    this.$scope = $scope;
    this.$uibModal = $uibModal;

    this.StorageService = StorageService;
    this.PropertyService = PropertyService;
    this.ContactService = ContactService;
    this.CommunityService = CommunityService;
    this.User = User;
  }

  $onInit() {
    this.config = this.resolve.config;
    this.schema = this.config.schema;
    this.title = this.config.title || "Form";
    this.model = this.config.model || {};
    this.form = this.config.form || ["*"];

    this.intro = this.config.intro;
    this.outro = this.config.outro;

    this.icon = this.config.icon;

    this.count = 0;
    this.maxCount = 4;

    let fnReady = _ => {
      let keys = Object.keys(this.schema.properties);
      keys.forEach(key => {
        if (this.schema.properties[key].hasOwnProperty("x-schema-form")) {
          let ref = this.schema.properties[key]["x-schema-form"];
          if (ref.type === 'entitylookup') {

            switch (ref.lookuptype) {
              case 'property':
                this.schema.properties[key]["entityLookupData"] = this.propertyData;
                this.schema.properties[key]["fnLookup"] = (key) => {
                  this.propertyLookup(key);
                };
                break;
              case 'user':
                this.schema.properties[key]["entityLookupData"] = this.userData;
                this.schema.properties[key]["fnLookup"] = (key) => {
                  this.userLookup(key);
                };
                break;
              case 'contact':
                this.schema.properties[key]["entityLookupData"] = this.contactData;
                this.schema.properties[key]["fnLookup"] = (key) => {
                  this.contactLookup(key);
                };
                break;
              case 'community':
                this.schema.properties[key]["entityLookupData"] = this.communityData;
                this.schema.properties[key]["fnLookup"] = (key) => {
                  this.communityLookup(key);
                };
                break;
            }

          } else if (ref.type == 'single-file-upload') {
            this.schema.properties[key]["fnOpenAssetUploadModal"] = (key) => {
              this.openAssetUploadModal(key);
            };
          }

        }
      })
    };

    this.PropertyService.query(data => {
      this.propertyData = data.filter(entity => !!entity.address).map(entity => {
        return {
          value: entity._id,
          name: entity.address.street + ", " + entity.address.city + ", " + entity.address.state + ", " + entity.address.zip,
          group: entity.community.name
        }
      });

      this.count++;
      if (this.count == this.maxCount)
        fnReady();
    });

    this.ContactService.query(data => {
      this.contactData = data.map(entity => {
        return {
          value: entity._id,
          name: this.getComposedName(entity),
          group: "General"
        }
      });

      this.count++;
      if (this.count == this.maxCount)
        fnReady();
    });

    this.CommunityService.query(data => {
      this.communityData = data.map(entity => {
        return {
          value: entity._id,
          name: entity.code + ": " + entity.name,
          group: "General"
        }
      });

      this.count++;
      if (this.count == this.maxCount)
        fnReady();
    });

    this.User.query(users => {
      this.userData = users.map(user => {
        return {
          value: user._id,
          name: user.shortName,
          group: 'General'
        }
      });

      this.count++;
      if (this.count == this.maxCount)
        fnReady();
    });

  };

  openAssetUploadModal(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result && result.length > 0) {
          that.model[key] = result[0];

          //that.getAttachmentFilename();
        }

      },
      function () { /* cancel */ }
    );

  }

  contactLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (contact) {
        that.model[key] = contact._id;
      },
      function () { /* cancel */ }
    );

  }

  userLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (user) {
        that.model[key] = user._id;
      },
      function () { /* cancel */ }
    );

  }

  propertyLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'propertyLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (property) {
        that.model[key] = property._id;
      },
      function () { /* cancel */ }
    );

  }

  communityLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'communityLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (community) {
        that.model[key] = community._id;
      },
      function () { /* cancel */ }
    );

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  ok(model) {
    this.close({$value: model});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      this.ok(this.model);
    }
  }
}

export default angular.module('conduu.schemaFormModal', [])
  .component('schemaFormModal', {
    template: require('./schema-form-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: SchemaFormModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/schema-form-modal/schema-form-modal.component.js